import { useState } from "react";
import { TableHeading } from "@/components/Table";
import { useCanManageCommitteesBool } from "@/hooks/useCapabilities";
import type { CommitteeCatalogScope } from "../committeeScope";
import type { CommitteeCatalogTab } from "../types";
import CommitteesCatalogTable from "./CommitteesCatalogTable";

type CommitteeCatalogSectionProps = {
  catalogTab: CommitteeCatalogTab;
  heading: string;
  body: string;
  sectionId?: string;
  sectionName?: string;
  canManageCommittees?: boolean;
  committeeScope?: CommitteeCatalogScope;
};

export default function CommitteeCatalogSection({
  catalogTab,
  heading,
  body,
  sectionId,
  sectionName,
  canManageCommittees: canManageCommitteesProp,
  committeeScope = "national"
}: CommitteeCatalogSectionProps) {
  const canManageFromPermission = useCanManageCommitteesBool();
  const canManageCommittees = canManageCommitteesProp ?? canManageFromPermission;
  const [addCommitteeDialogOpen, setAddCommitteeDialogOpen] = useState(false);
  const [canAddCommittee, setCanAddCommittee] = useState(false);

  return (
    <div className="w-full">
      <TableHeading
        heading={heading}
        body={body}
        actions={
          canManageCommittees && canAddCommittee
            ? [
                {
                  icon: "add",
                  label: "Add Committee",
                  onClick: () => setAddCommitteeDialogOpen(true),
                  testId: "add-committee-button"
                }
              ]
            : []
        }
      />
      <CommitteesCatalogTable
        catalogTab={catalogTab}
        sectionId={sectionId}
        sectionName={sectionName}
        canManageCommittees={canManageCommittees}
        committeeScope={committeeScope}
        addDialogOpen={addCommitteeDialogOpen}
        onAddDialogOpenChange={setAddCommitteeDialogOpen}
        onCanAddCommitteeChange={setCanAddCommittee}
      />
    </div>
  );
}
